import { ColorResult } from "react-color";
import { useSettings } from "../../../context";
import ColorSelect from "../../../../../../../library/color-select";

const ColorConfiguration = () => {
  const { updateFontSettings, getSelectedItemSettings } = useSettings();

  const currentSettings = getSelectedItemSettings();

  const handleColorChange = (color: ColorResult) => {
    const { r, g, b, a } = color.rgb;
    const rgbaString = `rgba(${r}, ${g}, ${b}, ${a})`;

    updateFontSettings({ color: rgbaString });
  };

  const onResetFontColor = () => {
    updateFontSettings({ color: "rgba(255, 255, 255, 1)" });
  };

  return (
    <ColorSelect
      color={currentSettings.configuration.font.color}
      onChange={handleColorChange}
      onReset={onResetFontColor}
    />
  );
};

export default ColorConfiguration;
